import { render, staticRenderFns } from "./CustomerInformation.vue?vue&type=template&id=58ba27a1&scoped=true&"
import script from "./CustomerInformation.vue?vue&type=script&lang=js&"
export * from "./CustomerInformation.vue?vue&type=script&lang=js&"
import style0 from "./CustomerInformation.vue?vue&type=style&index=0&id=58ba27a1&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58ba27a1",
  null
  
)

export default component.exports